import moment from 'moment'
import { gpsService } from '@/services/gps.service'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'GpsDialogSecondTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model del dialog para elegir la fecha de compra
        dateModal: false,
        // fecha formateada
        selectedDate: '',
        // model para el formulario
        isValidForm: false,
        // módulos de comunicaciones
        communicationModules: [],
        // loading
        loadingCommunicationModules: false,
    }),
    computed: {
    },
    created() {
        this.getcommunicationModules()
    },
    mounted() {
    },
    methods: {
        /**
         * Lo ejecuta el menú para seleccionar la fecha de compra
         */
        closeDateMenu() {
            this.dateModal = false
            this.selectedDate = this.model.buyDate ? moment(this.model.buyDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
        },
        /**
         * Arreglo de módulos de comunicaciones
         */
        getcommunicationModules() {
            this.loadingCommunicationModules = true
            gpsService.getcommunicationModules().then(data => {
                this.communicationModules = data
                this.loadingCommunicationModules = false
            })
        },
        /**
         * Cada vez que se modifica la selección del communicationModule, se cargan
         */
        communicationModuleSelectedFunction(newValue) {
            this.model.communicationModuleId = newValue._id ? newValue._id : newValue;
        }
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Actualizo el valor de la fecha seleccionada
         */
        model: {
            deep: true,
            immediate: true,
            handler() {
                this.selectedDate = this.model.buyDate ? moment(this.model.buyDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.gpsDialogSecondTabForm) {
                this.$refs.gpsDialogSecondTabForm.resetValidation()
            }
        }
    }
}
